import Vue from 'vue';

import axios from 'axios';
import Vuex from 'vuex';

// import Cookies from 'js-cookie'
import regionData from '../data/regions';
import { cardTypes } from '../helpers/billing-helper';
import { SHIPPING_COST } from '../helpers/constants';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    refreshToken: undefined,
    loggedIn: null,
    currentUser: {},
    selectedOrg: null,
    bundles: [],
    monthlySub: {},
    annualSub: {},
    cardToken: '',
    couponCode: '',
    couponDiscount: 0,
    couponError: '',
    order: {},
    orderDetails: {
      subscriptionID: 0,
      subscriptionQty: 0,
      outdoor: 0,
      indoor: 0,
    },
    billingDetails: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
    shippingDetails: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
    paymentDetails: {},
    orderTotal: {},
    systemError: '',
    orderResult: null,
    stripeId: '',
    paymentMethods: [],
    taxInfo: {
      calcID: '',
      taxAmount: 0,
      taxPercentage: 0,
    },
    taxError: '',
    taxLoading: false,
  },
  getters: {
    loggedIn(state) {
      return state.loggedIn
    },
    selectedOrg(state) {
      return state.selectedOrg
    },
    couponDiscount(state) {
      return state.couponDiscount
    },
    couponError(state) {
      return state.couponError
    },
    couponCode(state) {
      return state.couponCode
    },
    billingDetails(state) {
      return state.billingDetails
    },
    shippingDetails(state) {
      return state.shippingDetails
    },
    bundles(state) {
      return state.bundles
    },
    orderDetails(state) {
      return state.orderDetails
    },
    orderTotal(state) {
      return state.orderTotal
    },
    systemError(state) {
      return state.systemError
    },
    orderResult(state) {
      return state.orderResult
    },
    currentUser(state) {
      return state.currentUser
    },
    stripeId(state) {
      return state.stripeId
    },
    refreshToken(state) {
      return state.refreshToken
    },
    monthlySub(state) {
      return state.monthlySub
    },
    annualSub(state) {
      return state.annualSub
    },
    paymentMethods(state) {
      return state.paymentMethods
    },
    taxInfo(state) {
      return state.taxInfo
    },
    taxError(state) {
      return state.taxError
    },
    taxLoading(state) {
      return state.taxLoading
    }
  },
  mutations: {
    setRefreshToken(state, payload) {
      state.refreshToken = payload
    },
    setSelectedOrg(state, payload) {
      state.selectedOrg = payload
    },
    setCouponCode(state, payload) {
      state.couponCode = payload
    },
    setCouponDiscount(state, payload) {
      state.couponDiscount = payload
    },
    setCouponError(state, payload) {
      state.couponError = payload
    },
    setOrder(state, payload) {
      state.order = payload
    },
    setBillingDetails(state, payload) {
      state.billingDetails = payload
    },
    setShippingDetails(state, payload) {
      state.shippingDetails = payload
    },
    setBundles(state, payload) {
      state.bundles = payload
    },
    setCardToken(state, payload) {
      state.cardToken = payload
    },
    setPaymentDetails(state, payload) {
      state.paymentDetails = payload
    },
    setOrderDetails(state, payload) {
      state.orderDetails = payload
    },
    setCouponDiscount(state, payload) {
      state.couponDiscount = payload
    },
    setOrderTotal(state, payload) {
      state.setOrderTotal = payload
    },
    setSystemError(state, payload) {
      state.systemError = payload
    },
    setOrderResult(state, payload) {
      state.orderResult = payload
    },
    setLogin(state, payload) {
      state.loggedIn = payload
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload
    },
    setStripeId(state, payload) {
      state.stripeId = payload
    },
    setMonthly(state, payload) {
      state.monthlySub = payload
    },
    setAnnual(state,payload) {
      state.annualSub = payload
    },
    setPaymentMethods(state, payload) {
      state.paymentMethods = payload
    },
    setTaxInfo(state, payload) {
      state.taxInfo = payload
    },
    setTaxError(state, payload) {
      state.taxError = payload
    },
    setTaxLoading(state, payload) {
      state.taxLoading = payload
    }
  },
  actions: {
    removeError({ commit }) {
      setTimeout(() => {
        commit('setSystemError', null)
      }, 4000)
    },
    async logIn({ commit, dispatch }, payload) {
      await axios
        .post(`${process.env.VUE_APP_PORTAL}/login`, payload)
        .then((response) => {
          if (response.status === 200) {
            commit('setLogin', payload.email)
            const { data } = response.data
            // Cookies.set('refreshToken', data.refreshToken, {
            //   expires: 30,
            //   domain: "noiseaware.com",
            // })
            commit('setRefreshToken', data.refreshToken)
            dispatch('refreshUserToken')
            const userDataPayload = {
              url: process.env.VUE_APP_PORTAL,
              // token: Cookies.get('refreshToken'),
              token: data.refreshToken
            }
            dispatch('fetchUserData', userDataPayload)
          }
        })
        .catch((err) => {
          commit('setLogin', null)
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
    },
    async logOut({ commit }) {
      // Cookies.remove('refreshToken', { domain: process.env.VUE_APP_COOKIE_URL })
      commit('setRefreshToken', undefined)
      commit('setLogin', null)
      commit('setCurrentUser', {})
    },
    async refreshUserToken({state, commit}) {
      // const refreshToken = Cookies.get('refreshToken')
      const refreshToken = state.refreshToken
      if (refreshToken) {
        await axios
        .post(`${process.env.VUE_APP_PORTAL}/refresh`, { refreshToken })
        .then((res) => {
          // Cookies.set('refreshToken', res.data.data.userToken)
          commit('setRefreshToken', res.data.data.userToken)
        })
        // .catch(() => Cookies.remove('refreshToken'))
        .catch(() => commit('setRefreshToken', undefined))
      }
    },
    async fetchUserData({ state, commit, dispatch }, payload) {
      if (payload.token) {
        await axios
        .get(`${payload.url}/user/`, {
          headers: {
            authorization: `${payload.token}`,
          },
        })
        .then((res) => {
          commit('setCurrentUser', res.data.data)
          if (!state.loggedIn) commit('setLogin', res.data.data.email)
          if(res.data.data?.orgs.length === 1) commit('setSelectedOrg', res.data.data.orgs[0].id)
          if (!res.data.data.orgs) {
            commit(
              'setSystemError',
              "You don't seem to be in any organizations. If this is in error, contact support.",
            )
            dispatch('removeError')
          }
        })
        .catch((err) => {
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
      }
      
    },
    async fetchBundles({ commit }) {
      const body = { filter: [], sort: [] }
      await axios
        .post(`${process.env.VUE_APP_PORTAL}/bundles/list`, body)
        .then((res) => {
          commit('setBundles', res.data.data)
          const monthly = res.data.data.find((sub) => sub.billingCadence === "Monthly")
          const annual = res.data.data.find((sub) => sub.billingCadence === "Annual")
          commit('setMonthly', monthly)
          commit('setAnnual', annual)
          commit('setBundles', res.data.data)
          const details = {
            subscriptionID: annual.id,
            subscriptionQty: 0,
            outdoor: 0,
            indoor: 0,
          }
          commit('setOrderDetails', details)
        })
    },
    async getUserStripeId({ state, commit, dispatch }) {
      await axios
        .get(
          `${process.env.VUE_APP_PORTAL}/billing/organization/orgID/${state.selectedOrg}`,
          {
            headers: {
              // authorization: `${Cookies.get('refreshToken')}`,
              authorization: state.refreshToken
            },
          },
        )
        .then((response) => {
          commit('setStripeId', response.data.data.stripeID)
        })
        .catch((err) => {
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
    },
    buildPaymentDetails({ state, commit }) {
      const data = {
        billingDetails: state.billingDetails,
        shippingDetails: state.shippingDetails,
        couponCode: state.couponCode,
        paymentSourceID: state.cardToken.id || '',
        order: state.order,
        taxInfo: state.taxInfo,
      }
      const billCountry = regionData[data.billingDetails.country.toLowerCase()]?.alpha2 ?? regionData[data.shippingDetails.country.toLowerCase()]?.alpha2 ?? 'US'
      const shipCountry = regionData[data.shippingDetails.country.toLowerCase()]?.alpha2 ?? 'US'
      
      data.billingDetails.country = billCountry
      data.shippingDetails.country = shipCountry

      if (state.stripeId.length > 0) {
        data.stripeID = state.stripeId
        data.orgID = state.selectedOrg
      }
      commit('setPaymentDetails', data)
    },
    async makePayment({ state, commit, dispatch }) {
      dispatch('buildPaymentDetails')
      // const refreshToken = Cookies.get('refreshToken')
      const refreshToken = state.refreshToken
      let config = {}
      if (refreshToken) {
        config = {
          headers: {
            Authorization: `${refreshToken}`,
          },
        }
      }

      await axios
        .post(
          `${process.env.VUE_APP_PORTAL}/payments/`,
          state.paymentDetails,
          config,
        )
        .then((res) => {
          commit(
            'setOrderResult',
            res.data.data.subscription.latestInvoice,
          )
        })
        .catch((err) => {
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
    },
    handleCouponError({commit}, message) {
      commit('setCouponDiscount', 0)
      commit('setCouponError', message)
      setTimeout(() => {
        commit('setCouponError', '')
      }, 3000)
    },
    validateCoupon({ commit, dispatch}, payload) {
      commit('setCouponError', '')
      if (payload === '') dispatch('handleCouponError', 'Please enter a coupon code')
      else { 
        axios
        .get(`${process.env.VUE_APP_PORTAL}/payments/coupons?code=${payload}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.data.expiration) {
              const expirationDate = new Date(res.data.data.expiration)
              const now = new Date()

              if (expirationDate < now) {
                dispatch('handleCouponError', 'Coupon is expired')
              } else {
                commit('setCouponDiscount', res.data.data.amount)
              }              
            } else {
              commit('setCouponDiscount', res.data.data.amount)
            }
          }
        })
        .catch((err) => {
          dispatch('handleCouponError', 'Invalid Coupon')
        })
      }
    },
    calculateTotal({ state, commit, dispatch }) {
      commit('setCouponError', '')
      dispatch('buildPaymentDetails')
      axios
        .get(
          `${process.env.VUE_APP_PORTAL}/payments/calculateTotal`,
          state.paymentDetails,
        )
        .then((res) => {
          commit('setOrderTotal', res.data.data)
        })
        .catch((err) => {
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
    },
    getPaymentMethods({ state, commit, dispatch }) {
      commit('setPaymentMethods', [])

      const refreshToken = state.refreshToken
      let config = {}

      if (refreshToken) {
        config = {
          headers: {
            Authorization: `${refreshToken}`,
          },
        }
      }

      axios
        .get(
          `${process.env.VUE_APP_PORTAL}/billing/organization/paymentmethods/${state.selectedOrg}`,
          config
        )
        .then((res) => {
          const paymentMethods = res.data.data

          paymentMethods.forEach(pm => {
            pm.displayText = `${cardTypes[pm.cardInfo.brand]} ending in ${pm.cardInfo.last4} (Exp. ${pm.cardInfo.expMonth}/${pm.cardInfo.expYear}) -- ${pm.name}`
          })

          commit('setPaymentMethods', res.data.data)
        })
        .catch((err) => {
          commit('setSystemError', err.response.data.detail)
          dispatch('removeError')
        })
    },
    async calculateTax({ state, commit }) {
      commit('setTaxLoading', true)
      commit('setTaxError', '')
      commit('setTaxInfo', { calcID: '', taxAmount: 0, taxPercentage: 0 })

      const orderItems = []
      const couponMultiplier = 1 - (state.couponDiscount / 100)
      const selectedBundle = state.bundles.find(b => b.id === state.orderDetails.subscriptionID)

      const subscriptionLineItem = selectedBundle?.lineItems?.find(li => li.recurring)
      const indoorSensorBundle = state.bundles.find(b => b.type === 'hardware' && (b.viewPriority === 1 || b.viewPriority === 3))
      const outdoorSensorBundle = state.bundles.find(b => b.type === 'hardware' && (b.viewPriority === 2 || b.viewPriority === 4))

      // Numeral API does not consider the quantity when calculating tax 
      // Use quantity 1 with total amount for all order items

      // subscription item 
      if (state.orderDetails.subscriptionQty > 0 && selectedBundle?.price) {
        orderItems.push({
          amount: Math.round(selectedBundle.price * state.orderDetails.subscriptionQty * couponMultiplier),
          quantity: 1,
          referenceLineItemID: subscriptionLineItem?.sku || ''
        })
      }

      // additional indoor sensors
      if (state.orderDetails.indoor > 0 && indoorSensorBundle?.price) {
        orderItems.push({
          amount: Math.round(indoorSensorBundle.price * state.orderDetails.indoor * couponMultiplier),
          quantity: 1,
          referenceLineItemID: indoorSensorBundle.lineItems?.[0]?.sku || ''
        })
      }

      // outdoor sensors
      if (state.orderDetails.outdoor > 0 && outdoorSensorBundle?.price) {
        orderItems.push({
          amount: Math.round(outdoorSensorBundle.price * state.orderDetails.outdoor * couponMultiplier),
          quantity: 1,
          referenceLineItemID: outdoorSensorBundle.lineItems?.[0]?.sku || ''
        })
      }

      // shipping (no coupon applied)
      orderItems.push({
        amount: SHIPPING_COST * 100, // convert to cents
        quantity: 1,
        referenceLineItemID: process.env.VUE_APP_SHIPPING_SKU
      })

      const payload = {
        orderItems,
        taxLocationInformation: {
          addressLine1: state.shippingDetails.addressLine1,
          addressType: 'shipping',
          city: state.shippingDetails.city,
          country: state.shippingDetails.country,
          state: state.shippingDetails.state,
          zip: state.shippingDetails.zip,
        }
      }

      try {
        const res = await axios.post(`${process.env.VUE_APP_PORTAL}/payments/calculateTax`, payload)
        const taxData = res.data.data                                                                                                                                       
        
        if (!taxData?.calcID || taxData?.taxAmount == null) {                                                                                                                
          throw new Error('Invalid tax response')                                                                                                                           
        }                            

        commit('setTaxInfo', taxData)
      } catch (err) {
        if (err.response?.status === 400) {
          commit('setTaxError', 'Failed to calculate tax, please verify your shipping address.')
        } else {
          commit('setTaxError', 'Unable to calculate tax information, please try again soon.')
        }
      } finally {
        commit('setTaxLoading', false)
      }
    }
  },
})
